import React from "react";
import { Link, useLocation } from "react-router-dom";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { groupTripL } from "@/i18n/groupTrips";
import { clearShareTarget, useShareTarget } from "./shareTarget";

/**
 * While a traveller searches for their group (the chat's "Search" button),
 * a line under the header says which group the offer will go to, with the
 * way back to it and a way to stop. Night blue, the group bubble's colour.
 */
export default function ShareTargetBanner() {
  const target = useShareTarget();
  const { user } = useAuth() || {};
  const { lang } = useSettings();
  const location = useLocation();
  if (!target || !user || /^\/groups(\/|$)/.test(location.pathname)) return null;
  const l = groupTripL[lang] || groupTripL.en;
  return (
    <div role="status" data-testid="share-target-banner" className="tk-on-ink bg-touki-night text-white">
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 sm:px-6">
        <MagnifyingGlass size={18} weight="bold" aria-hidden="true" className="shrink-0" />
        <p className="min-w-0 flex-1 text-body-sm">
          <span className="font-semibold">{l.sharingFor(target.title)}</span>
          <span className="hidden text-touki-on-ink-muted sm:inline"> {l.sharingHint}</span>
        </p>
        <Link to={`/groups/${encodeURIComponent(target.id)}`} className="inline-flex min-h-11 shrink-0 items-center rounded-md px-2 text-body-sm font-semibold underline underline-offset-4">
          {l.backToGroup}
        </Link>
        <button type="button" onClick={clearShareTarget} aria-label={l.stopSharing} title={l.stopSharing} data-testid="share-target-stop"
          className="inline-flex size-11 shrink-0 items-center justify-center rounded-full transition-colors duration-fast hover:bg-touki-night-dark">
          <X size={18} weight="bold" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
